<template>
    <!-- Wait until we have all the data we need before rendering any header -->
    <div v-if="!isDataLoaded">
        <!-- Loading state - don't show any header -->
    </div>
    <div class="title-menu" v-else-if="shouldShowOldHeader">
        <div class="title">
            <img src="../assets/experian-logo.svg" alt="Experian" />
            <span>EligibilityIQ</span>

        </div>
        <user-menu @signOut="signOut" v-if="authenticated" />
    </div>
    <div v-else-if="authenticated && shouldShowSaasHeader">
        <SaasHeader :scriptLoading="saasHeaderLoading" @ready="$emit('ready')" />
    </div>

</template>

<script>
    import { mapGetters } from 'vuex'
    import UserMenu from './UserMenu.vue'
    import SaasHeader from './SaasHeader.vue'

    export default {
        name: 'TitleMenu',
        components: {
            'user-menu': UserMenu,
            SaasHeader
        },
        props: {
            authenticated: {
                type: Boolean,
                required: true,
                default: false
            },
            saasHeaderLoading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters(['user','atpLiteHeaderEnabled']),
            isExpnssoUser() {
                // If user.Name does NOT contain '@', it's an expnsso user
                return this.user && this.user.name && !this.user.name.includes('@');
            },
            isDataLoaded() {
                // Only render when we have all necessary data
                if (!this.authenticated) {
                    // If not authenticated, we can show immediately (no header needed)
                    return true;
                }
                // For authenticated users, wait for both user data AND feature flag
                // Feature flag must be explicitly true or false (not undefined)
                return this.user !== null && this.atpLiteHeaderEnabled !== undefined;
            },
            shouldShowOldHeader() {
                // Show old header if:
                // 1. User is expnsso user (EIQ user without @), OR
                // 2. Feature flag is explicitly false (disabled)
                return this.isExpnssoUser || this.atpLiteHeaderEnabled === false;
            },
            shouldShowSaasHeader() {
                // Show SaaS header only if feature flag is explicitly true
                return this.atpLiteHeaderEnabled === true;
            }
        },
        methods: {
            signOut() {
                this.$emit('signOut')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../styles/base';
    @import '../../node_modules/hd-styles/base';
    @import '../../node_modules/hd-styles/modules/mixins';

    .title-menu {
        display: flex;
        align-items: center;
        padding: 16px $spacing-unit;
        justify-content: space-between;
    }

    .title {
        display: flex;
        align-items: center;
    }

    img {
        transform: translateX(-8px);
    }
</style>